<div class="table-container">
    <div class="sticky-upload" [class.disabled-overlay]="isEditingInList">
        <div class="upload-wrapper-flex">
            <media-details 
                [currentTicket]="currentTicket" 
                [isDisabled]="isEditingInList">
            </media-details>
            <div class="upload-action-right">
                <button class="btn-save-fixed" 
                        (click)="saveFromTop()" 
                        [disabled]="isEditingInList">
                    <span class="material-icons">save</span>
                </button>
            </div>
        </div>
    </div>

    <table class="table">
        <tbody>
        <ng-container *ngFor="let media of medias | async">
            <tr class="media-row">
                <td class="media-cell">
                    <div class="media-container" [class.expanded]="selectedMedia?.id === media.id">
                        <div class="row-top">
                            <div class="image-wrapper">
                                <img *ngIf="isImage(media.contentType)"
                                     [src]="thumbnailUrls.get(media.id) || 'assets/img/placeholder.png'"
                                     class="thumb-img"
                                     (click)="openPreview(media); $event.stopPropagation()"
                                     (error)="handleImageError($event)">
                                <span *ngIf="!isImage(media.contentType)" class="material-icons file-icon">
                                    description
                                </span>
                            </div>
                        </div>

                        <div class="row-bottom" (click)="toggleDescription(media)">
                            <span class="media-name">{{ media.name }}</span>
                            <div class="row-bottom-actions">
                                <button class="btn-download"
                                        (click)="downloadMedia(media); $event.stopPropagation()">
                                    <span class="material-icons">file_download</span>
                                </button>
                                <button class="btn-delete"
                                        (click)="deleteMedia(media); $event.stopPropagation()">
                                    <span class="material-icons-outlined">delete</span>
                                </button>
                                <span class="material-icons arrow-icon">
                                    {{ selectedMedia?.id === media.id ? 'expand_less' : 'expand_more' }}
                                </span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

            <tr *ngIf="selectedMedia?.id === media.id" class="details-row">
                <td class="details-cell">
                    <div class="details-grid">
                        <div class="detail-item">
                            {{ 'mediaDetails.filename' | translate }}: <strong>{{ media.id }}</strong>
                        </div>
                        <div class="detail-item">
                            {{ 'mediaDetails.archivedLabel' | translate }}: <strong>{{ media.archived }}</strong>
                        </div>
                        <div class="detail-item">
                            {{ 'mediaDetails.fileInfoLabel' | translate }}: <strong>{{ media.fileInfo?.fileName }}</strong>
                        </div>
                        <div class="detail-item">
                            {{ 'mediaDetails.contentTypeLabel' | translate }}: <strong>{{ media.contentType }}</strong>
                        </div>
                        <div class="detail-item">
                            {{ 'mediaDetails.extensionLabel' | translate }}: <strong>{{ media.extension }}</strong>
                        </div>
                        <div class="detail-item">
                            {{ 'mediaDetails.originalLabel' | translate }}: <strong>{{ media.name }}</strong>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-container>
        </tbody>
    </table>
</div>
